<template>
    <v-card color="green" class="pa-2 fill-height flex-grow-1 d-flex flex-column">
        <v-card-title class="justify-center text-center text-wrap">
            {{ title }}
        </v-card-title>
        <v-card-text class="pt-2">
            <v-row dense align="center" justify="center">
                <v-col cols="12">
                    <v-btn
                        variant="tonal"
                        color="white"
                        density="compact"
                        :elevation="0"
                        block
                        @click="goTab('received')"
                    >
                        {{ $t("dashboard.reservationsReceived") }}: {{ received }}
                    </v-btn>
                </v-col>
                <v-col cols="12" class="mt-2">
                    <v-btn
                        variant="tonal"
                        color="white"
                        density="compact"
                        :elevation="0"
                        block
                        @click="goTab('contracted')"
                    >
                        {{ $t("dashboard.reservationsContracted") }}: {{ contracted }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "DashboardReservationCard",
    props: {
        title: { type: String, required: true },
        received: { type: Number, default: 0 },
        contracted: { type: Number, default: 0 },
        entryType: { type: String, required: true, validator: (v) => ["truck", "ware"].includes(v) },
    },
    methods: {
        goTab(tab) {
            const name = this.entryType === "truck" ? "TruckReservations" : "WareReservations";
            this.$router.push({ name, query: { tab } });
        },
    },
};
</script>
